import { ActionExtended } from "src/_common/interfaces/ActionExtended";
import { ACTIONS } from "src/_config";

export interface EventReducer {
  getEventGameList: any;
  getEventGameDetails: any;
  getEventStatusMessage: any;
  login_required: number;
  getLeaderBoard: any;
  getTvImageDetails: any;
  cmsList: any;
  gameDetails: any;
}

const initialState: EventReducer = {
  getEventGameList: null,
  getEventGameDetails: null,
  getEventStatusMessage: null,
  login_required: 0,
  getLeaderBoard: null,
  getTvImageDetails: null,
  cmsList: null,
  gameDetails: null,
};

const eventReducer = (state = initialState, action: ActionExtended) => {
  switch (action.type) {
    case ACTIONS.EVENT.GET_EVENT_GAME:
      return {
        ...state,
        getEventGameList: action.payload,
      };
    case ACTIONS.EVENT.GET_EVENT_GAME_DETAILS:
      return {
        ...state,
        getEventGameDetails: action.payload,
      };
    case ACTIONS.EVENT.GET_STATUS_MESSAGE:
      let x: any = null;
      if (action.payload && action.payload.status_text) {
        x = action.payload.status_text;
      }
      console.log({ x });
      return {
        ...state,
        getEventStatusMessage: x,
      };
    case ACTIONS.EVENT.LEADERBOARD:
      return {
        ...state,
        getLeaderBoard: action.payload,
      };

    // Update Game Status at Event game list page
    case ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST:
      var { socketData, userId } = action.payload;
      let eventList = state.getEventGameList;
      if (eventList && eventList.length) {
        var findGameIndex = eventList.findIndex((x: any) => x.id === socketData.id);
        if (findGameIndex >= 0) {
          eventList[findGameIndex].status = socketData.status;
        }
      }

      return {
        ...state,
        getEventGameList: eventList && eventList.length ? eventList.map((x: any) => Object.assign(x)) : [],
      };

    //Update game event details data
    case ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS:
      var { socketData, userId } = action.payload;
      let gameDetails = state.getEventGameDetails;
      if (gameDetails && gameDetails.event_dtls && gameDetails.event_dtls.id == socketData.id) {
        gameDetails.event_dtls.status = socketData.status;
      }
      return {
        ...state,
        getEventGameDetails: {
          ...gameDetails,
        },
      };
    case ACTIONS.EVENT.GET_GAME_DETAILS:
      return {
        ...state,
        gameDetails: action.payload,
      };

    case ACTIONS.EVENT.GAME_LOGIN_REQUIRED:
      return {
        ...state,
        login_required: action.payload,
      };

    //Update game status message
    case ACTIONS.EVENT.GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST:
      var { socketData, userId } = action.payload;
      let statusMessageList = state.getEventStatusMessage;
      if (statusMessageList && statusMessageList.length) {
        statusMessageList.map((x: any, index: number) => {
          if (x.rodeo_event_id === socketData.rodeo_event_id) {
            statusMessageList[index].status_text = socketData.text;
          }
        });
      }
      return {
        ...state,
        getEventStatusMessage:
          statusMessageList && statusMessageList.length ? statusMessageList.map((x: any) => Object.assign(x)) : [],
      };
    case ACTIONS.EVENT.CMS_LIST:
      return {
        ...state,
        cmsList: action.payload,
      };
    default:
      return state;
  }
};

export default eventReducer;
